/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";

import AboutUs from "./Content/AboutUS";
import TermsOfUse from "./Content/Terms";
import Policy from "./Content/Policy";
import { backButton } from "components/Form/FormField";
import NotFoundPage from "client/views/NotFoundPage.tsx";

import legalPageStyle from "assets/jss/views/legalPage/legalPageStyle.jsx";
const styles = createStyles(legalPageStyle as any);

interface Props extends WithStyles<typeof styles> {
  classes: any;
  match: any;
  history: any;
}

const LegalPageBase: React.FC<Props> = ({ classes, match, history }: Props) => {
  const { tab } = match.params;
  const legalPages = { about: AboutUs, terms: TermsOfUse, policy: Policy };
  const Tag: any = legalPages[tab] || NotFoundPage.component;

  return (
    <div className={classes.pageBackground}>
      {backButton(history)}
      <div className={classes.container}>
        <div className={classes.contentBox}>
          <Tag />
        </div>
      </div>
    </div>
  );
};

const base: any = LegalPageBase;
export const LegalPage: any = { component: withStyles(styles)(base) };
